import React from "react";
import theme from "../../../styles/theme";



const Page25 = () => {
  return (

 
    <div>
    <h2>"Page 25" </h2>
    </div>


  );
};

export default Page25;
